import { AnyAction } from 'redux';
import { MODAL_ACTION_CONSTANTS } from '../../constants/cloud-admin';
import { ModalPosition } from 'actions/cloud-admin';

export interface ModalsState {
  showModal: boolean;
  modalType: string | null;
  modalPosition: ModalPosition;
  feature: string | null;
}

const initialState: ModalsState = {
  showModal: false,
  modalType: null,
  modalPosition: { top: 222, right: 0 },
  feature: null,
};

export function ModalsReducer(state: ModalsState = initialState, action: AnyAction): ModalsState {
  switch (action.type) {
    case MODAL_ACTION_CONSTANTS.SHOWMODAL:
      return { ...state, showModal: true, modalType: action.modalType, feature: action.feature };
    case MODAL_ACTION_CONSTANTS.HIDEMODAL:
      return { ...state, showModal: false, modalType: null, feature: null };
    case MODAL_ACTION_CONSTANTS.POSITION_MODAL:
      return { ...state, modalPosition: action.modalPosition };
    default:
      return state;
  }
}
